import angular from 'angular'
import controller from './controller.js'
import template from './template.html'
import userController from './user/userTimestamps.controller.js'
import userTemplate from './user/userTimestamps.html'
import timesheetsTab from './timesheets/shiftsByStatusTab.html'
import editableTimestampTemplate from './timesheets/editableTimestamp.html'
import directDepositController from '../profile-webview/direct-deposit/direct-deposit.ctrl.js'
import 'angular-ui-grid'
import 'angular-ui-grid/ui-grid.min.css'

import mainMenu from '../../shared/menu/menu.html'
import Debug from 'debug'

import './style.css'
const debug = Debug('app:payroll')

const menu = '<h2 class="dash-header" hide-xs><span>Earnings</span></h2><span flex></span>'

export default angular.module('payroll', ['ui.router', 'ui.grid'])
  .directive('focusOn', function () {
    return function (scope, elem, attr) {
      scope.$on(attr.focusOn, function (e) {
        elem[0].focus()
      })
    }
  })
  .directive('tabShiftsByStatus', function () {
    return {
      restrict: 'E',
      template: timesheetsTab,
      controller: ['$scope', function ($scope) {
      }],
      controllerAs: 'c',
      scope: {
        label: '=',
        status: '=',
        shifts: '=',
        users: '=',
        jobs: '=',
        ctrl: '=',
        searchByLastNameText: '='
      }
    }
  })
  .directive('editableTimestamp', function () {
    return {
      restrict: 'E',
      template: editableTimestampTemplate,
      controller: ['$scope', function ($scope) {
        this.cancelTimeEdit = function () {
          $scope.ctrl.cancelTimeEdit($scope.user, $scope.type)
        }
        this.onClickPrev = function () {
          $scope.ctrl.substractDayFromEditedTime($scope.user, $scope.type)
          $scope.prev = false
          $scope.next = true
        }
        this.onClickNext = function () {
          $scope.ctrl.addDayToEditedTime($scope.user, $scope.type)
          $scope.next = false
          $scope.prev = true
        }
      }],
      controllerAs: 'c',
      scope: {
        type: '=',
        user: '=',
        ctrl: '=',
        prev: '=prev',
        next: '=next'
      }
    }
  })
  .config(function ($stateProvider) {
    'ngInject'

    $stateProvider.state('app.payroll', {
      url: '/payroll/:week/company/:companyId',
      params: {
        week: { squash: true, dynamic: true, value: null },
        companyId: { squash: true, value: null, dynamic: true }
      },
      resolve: {
        company: (Companies) => {
          'ngInject'
          return Companies.getCompanyData()
        },
        week: ($stateParams) => {
          'ngInject'
          let now = new Date()
          let weeksSinceEpoch = Math.floor((now / 1000 - 3.744e5) / 6.048e5)
          if ($stateParams.week !== null && !isNaN($stateParams.week) && $stateParams.week !== '') {
            weeksSinceEpoch = $stateParams.week
          }
          return weeksSinceEpoch
        }
      },
      views: {
        content: {
          controller: controller,
          controllerAs: 'ctrl',
          template: template
        },
        menu: {
          template: mainMenu + menu
        }
      }
    })
    $stateProvider.state('app.pay', {
      url: '/pay/:week/user/:userId',
      params: {
        week: { squash: true, dynamic: true, value: null },
        userId: { squash: true, value: null }
      },
      resolve: {
        user: (Auth) => {
          'ngInject'
          return Auth.getDetails()
        },
        payroll: (Payroll, $mdDialog, $state, $stateParams) => {
          'ngInject'
          let now = new Date()
          let weeksSinceEpoch = Math.floor((now / 1000 - 3.744e5) / 6.048e5 - 1)
          if ($stateParams.week !== null && !isNaN($stateParams.week) && $stateParams.week !== '') {
            weeksSinceEpoch = $stateParams.week
          } else {
            $stateParams.week = weeksSinceEpoch
          }
          return Payroll.getUserPayroll({ week: $stateParams.week, userId: $stateParams.userId })
            .catch((err) => {
              debug(err)
              $mdDialog.show(
                $mdDialog.alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(true)
                  .title('Server Error')
                  .textContent('There was an error fetching clock in data. Please try again later.')
                  .ariaLabel('Server Error')
                  .ok('OK')
              ).then($state.go('login'))
            })
        }
      },
      views: {
        content: {
          controller: userController,
          controllerAs: 'p',
          template: userTemplate
        },
        menu: {
          template: mainMenu + menu
        }
      }
    })
  })
  .controller('directDepositController', [
    'PayrollService',
    '$mdDialog',
    '$mdToast',
    'userId',
    'onDirectDepositSaveSuccess',
    directDepositController
  ]);
